module.exports = __webpack_public_path__ + "static/logo-787dd55c32f215d8424f1ce4232162c7.png";